<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <simple-wizard :start-index="index" @update:startIndex="updateIndex" class="plat" wizardClass = "plat">
        <template slot="header">
          <div></div>
        </template>
        <wizard-tab >
          <template slot="label"> {{$I18n("cloud_stor")}} </template>
          <div>
            <md-card-content>
              <add-button @click="table_addItem">{{$I18n("add_cloud")}}</add-button>
              <!-- 卡片主体(表格) -->
              <md-table v-model="tableData">
                <md-table-row slot="md-table-row" slot-scope="{ item }" >
                  <md-table-cell :md-label="$I18n('platform_id')">{{ item.id }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('platform_name')">
                    {{ item.name }}
                  </md-table-cell>
                  <md-table-cell v-if="UserInfo.role_id < 10000" :md-label="$I18n('company')">
                    {{ item.comp_name }}
                  </md-table-cell>

                  <md-table-cell :md-label="$I18n('zone')">
                    {{ item.zone }}
                  </md-table-cell>
                  <md-table-cell :md-label="$I18n('state')">
                    {{ item.state_name }}
                  </md-table-cell>

                  <md-table-cell :md-label="$I18n('type_name')">
                    {{ item.type_name }}
                  </md-table-cell>
                  <md-table-cell :md-label="$I18n('platform_bucket')">{{ item.bucket }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('platform_appKey')">{{ (item.app_key && item.app_key.length > 20) ? item.app_key.slice(0,15)+"..." :item.app_key }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('platform_endPoint')">{{ (item.end_point && item.end_point.length > 20) ? item.end_point.slice(0,15)+"..." :item.end_point }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.create_time }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                    <md-button @click.stop="table_editItem(item)" class="md-just-icon md-round md-info">
                      <md-icon>edit</md-icon>
                    </md-button>
                    <md-button @click.stop="table_deleteItem(item)" class="md-just-icon md-round md-danger md-info left-icon">
                      <md-icon>close</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
                <md-table-empty-state slot="md-table-empty-state">
                  {{$I18n("none_data")}}
                </md-table-empty-state>
              </md-table>
            </md-card-content>
            <!-- 翻页 -->
            <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
          </div>
        </wizard-tab>
        <wizard-tab >
          <template slot="label"> {{$I18n("log")}} </template>
          <div>
            <md-card-content>
              <add-button @click="table_addItem">{{$I18n("add_cloud")}}</add-button>
              <!-- 卡片主体(表格) -->
              <md-table v-model="tableData">
                <md-table-row slot="md-table-row" slot-scope="{ item }" >
                  <md-table-cell :md-label="$I18n('platform_id')">{{ item.id }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('platform_name')">
                    {{ item.name }}
                  </md-table-cell>
                  <md-table-cell v-if="UserInfo.role_id < 10000" :md-label="$I18n('company')">
                    {{ item.comp_name }}
                  </md-table-cell>

                  <md-table-cell :md-label="$I18n('zone')">
                    {{ item.zone }}
                  </md-table-cell>
                  <md-table-cell :md-label="$I18n('state')">
                    {{ item.state_name }}
                  </md-table-cell>
                  <md-table-cell :md-label="$I18n('type_name')">
                    {{ item.type_name }}
                  </md-table-cell>
                  <md-table-cell :md-label="$I18n('platform_bucket')">{{ item.bucket }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('platform_appKey')">{{ (item.app_key && item.app_key.length > 20) ? item.app_key.slice(0,15)+"..." :item.app_key }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('platform_endPoint')">{{ (item.end_point && item.end_point.length > 20) ? item.end_point.slice(0,15)+"..." :item.end_point }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.create_time }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                    <md-button @click.stop="table_editItem(item)" class="md-just-icon md-round md-info">
                      <md-icon>edit</md-icon>
                    </md-button>
                    <md-button @click.stop="table_deleteItem(item)" class="md-just-icon md-round md-danger md-info left-icon">
                      <md-icon>close</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
                <md-table-empty-state slot="md-table-empty-state">
                  {{$I18n("none_data")}}
                </md-table-empty-state>
              </md-table>
            </md-card-content>
            <!-- 翻页 -->
            <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
          </div>
        </wizard-tab>
        <wizard-tab >
          <template slot="label"> {{$I18n("system")}} </template>
          <div>
            <md-card-content>
              <add-button @click="table_addItem">{{$I18n("add_cloud")}}</add-button>
              <!-- 卡片主体(表格) -->
              <md-table v-model="tableData">
                <md-table-row slot="md-table-row" slot-scope="{ item }" >
                  <md-table-cell :md-label="$I18n('platform_id')">{{ item.id }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('platform_name')">
                    {{ item.name }}
                  </md-table-cell>
                  <md-table-cell v-if="UserInfo.role_id < 10000" :md-label="$I18n('company')">
                    {{ item.comp_name }}
                  </md-table-cell>

                  <md-table-cell :md-label="$I18n('zone')">
                    {{ item.zone }}
                  </md-table-cell>
                  <md-table-cell :md-label="$I18n('state')">
                    {{ item.state_name }}
                  </md-table-cell>
                  <md-table-cell :md-label="$I18n('type_name')">
                    {{ item.type_name }}
                  </md-table-cell>
                  <md-table-cell :md-label="$I18n('platform_bucket')">{{ item.bucket }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('platform_appKey')">{{ (item.app_key && item.app_key.length > 20) ? item.app_key.slice(0,15)+"..." :item.app_key }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('platform_endPoint')">{{ (item.end_point && item.end_point.length > 20) ? item.end_point.slice(0,15)+"..." :item.end_point }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.create_time }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                    <md-button @click.stop="table_editItem(item)" class="md-just-icon md-round md-info">
                      <md-icon>edit</md-icon>
                    </md-button>
                    <md-button @click.stop="table_deleteItem(item)" class="md-just-icon md-round md-danger md-info left-icon">
                      <md-icon>close</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
                <md-table-empty-state slot="md-table-empty-state">
                  {{$I18n("none_data")}}
                </md-table-empty-state>
              </md-table>
            </md-card-content>
            <!-- 翻页 -->
            <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
          </div>
        </wizard-tab>
      </simple-wizard>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :large = "openModalType==='import'"
      :right = "!openModalType.includes('delete')"
      :submitBtn = "openModalType !=='import'"
      @submit= "modal_submit"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", modalData.Form.name)}}</div>
        <!-- 修改/添加弹窗 -->
        <div v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass, timestampToString1000 } from "@/common/tools.js";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  props: ["userinfo_sys"],
  components: {
    SimpleWizard,
    WizardTab,
  },
  data() {
    return {
      // 模式：1：云存储，2：日志，3：系统
      index:0,
      mode :1,
      // 表格相关
      ...({
        icon  : "computer",
        title : this.$I18n("payment_platform"),
        tableInitData : [], // 表格数据
        compData : [], // 公司数据
        // 分页相关
        pageSize : 10,
        currentPage : 1,
        total : 0,
        // 弹窗相关
        openModal: false,  // 是否打开弹窗
        openModalType : "upload", // 弹窗类型
        modalTitle : "",  // 弹窗标题
      }),
      // 弹窗表单相关
      ...({
        modalData : new FormClass({
          type: 2,
          mode: 1,
          state:1,
          support_img:2,
          comp_id : "",
          name: "",
          zone: "",
          app_key: "",
          app_secret: "",
          end_point: "",
          port: "",
          bucket: "",
          store_path: "",
          // platform_file_prefix: "",
        },{
          mode  : "required",
          name : "required",
          zone  : "required",
          app_key  : "required",
          app_secret : "required",
          end_point  : "required",
          port : "number",
          bucket : "required",
        }),
      })
    };
  },
  mounted : function() {
    this.api_getPageData();
    this.api_getComp().then(() => {
      this.modalData.SetInit(this.compData[0].comp_id, "comp_id")
    });
  },
  watch: {
    currentPage() {
      this.api_getPageData();
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData]
          .map(item => {
            let comp_name = "";
            let comp_item = this.compData.filter(i => {return i.comp_id === item.comp_id})
            if(comp_item[0]){
              comp_name = comp_item[0].comp_name;
            }
            let type_name = "";
            switch(item.type){
              case 1:
                type_name = this.$I18n("link_visual");
                break;
              case 2:
                type_name = "Aliyun"
                break;
              case 3:
                type_name = "AWS"
                break;
              case 4:
                type_name = "E2E";
                break;
              case 6:
                type_name = "Oracle"
                break;
              default:
                type_name = this.$I18n("unknow_state");
                break;
            }
            let state_name = "";
            switch(item.state){
              case 1:
                state_name = this.$I18n("open");
                break;
              case 2:
                state_name = this.$I18n("closed");
                break;
              default:
                item.state = 2;
                state_name = this.$I18n("closed");
                break;
            }

            return {
              comp_name,
              type_name,
              state_name,
              create_time: timestampToString1000(item.gmt_create),
              ... item,
            }
          })
      }
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("mode"),
          keys    : "mode",
          type    : "select",
          options : [
            {id: "1", name : this.$I18n("cloud_stor")},
            {id: "2", name : this.$I18n("log")},
            {id: "3", name : this.$I18n("system")},
          ],
          required: true,
        },{
          label   : this.$I18n("company"),
          keys    : "comp_id",
          type    : "select",
          options : this.compData.map(i => {
            return {
              id  : i.comp_id,
              name: i.comp_name,
            }
          }),
          placeholder: this.$I18n('pls_input_role_id'),
          required: true,
        },{
          label   : this.$I18n("state"),
          keys    : "state",
          type    : "select",
          options : [
            {id: "1", name : this.$I18n("open")},
            {id: "2", name : this.$I18n("closed")},
          ],
          required: true,
        },{
          label   : this.$I18n("platform_type"),
          keys    : "type",
          type    : "select",
          options : [
            {id: "2", name : "Aliyun"},
            {id: "3", name : "AWS"},
            {id: "4", name : "E2E"},
            {id: "6", name : "Oracle"},
          ],
          placeholder: this.$I18n('pls_input_role_id'),
          required: true,
        },{
          label   : this.$I18n("platform_name"),
          keys    : "name",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("zone"),
          keys    : "zone",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("platform_appKey"),
          keys    : "app_key",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("platform_appSecret"),
          keys    : "app_secret",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("platform_endPoint"),
          keys    : "end_point",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("platform_port"),
          keys    : "port",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("platform_bucket"),
          keys    : "bucket",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("platform_store_path"),
          keys    : "store_path",
          type    : "input",
        },{
        //   label   : this.$I18n("platform_file_prefix"),
        //   keys    : "platform_file_prefix",
        //   type    : "input",
        // },{
          label   : this.$I18n("support_img_check"),
          keys    : "support_img",
          type    : "select",
          options : [
            {id: "1", name: this.$I18n("support")},
            {id: "2", name: this.$I18n("no_support")},
          ],
        },
      ]
    },
  },
  methods: {
    updateIndex(newIndex){
      this.index = newIndex;
      if(isNaN(newIndex)){
        this.mode = 1;
      } else {
        this.mode = parseInt(newIndex) + 1;
      }
      this.currentPage = 1;
      this.api_getPageData();
    },
    table_addItem(){
      this.modalTitle = this.$I18n("add");
      this.modalData.Reset();
      this.modalData.Form.mode = this.mode;
      this.openModalType = "add";
      this.$refs.modal.open();
    },
    table_editItem(item){
      this.modalTitle = this.$I18n("edit");
      this.modalData.Update(item);
      this.openModalType = "edit";
      this.$refs.modal.open();
    },
    table_deleteItem(item){
      this.modalTitle = this.$I18n("delete");
      this.modalData.Update(item);
      this.openModalType = "delete";
      this.$refs.modal.open();
    },
    // 获取公司信息
    api_getComp (){
      //获取菜单
      return this.$api.getCompanyList({})
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch("", () => {
          this.compData = [];
        }))
    },
    // 获取页面信息
    api_getPageData(){
      // 获取角色
      this.$api.getCloudOssInfo({
        sys : this.userinfo_sys,
        mode: this.mode,
        page_size: this.pageSize,
        page_no  : this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
      this.openModal = false;
    },
    // 提交表单
    modal_submit () {
      if (this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_input_content"));
        return;
      }
      let opcode = "";
      if(this.openModalType === "add"){
        opcode = "addCloudOssInfo";
      } else if (this.openModalType === "edit"){
        opcode = "editCloudOssInfo";
      } else if (this.openModalType === "delete"){
        opcode = "delCloudOssInfo";
      }
      this.$api[opcode]({
        ...this.modalData.Form,
        sys: this.userinfo_sys,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.$refs.modal.close();
          this.api_getPageData();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>